import { get } from '../../shared/utils/fetch.util'

export const getUser = id => get(`/v1/app-users/${id}`)
export const getUserListings = userId => get(`/v1/listings/user/${userId}`)
